export const ENVIRONMENT_INFO = {
  VR: {
    serviceName: "vr",
    host: "vr.ht.chahinehamila.com",
    protocol: "https",
    mountPath: "/api/",
    port: 443,
    baseUrl: "https://vr.ht.chahinehamila.com/api/"
  }
};
